export enum PackageLocationType {
  City = "CITY",
  Hotel = "HOTEL",
  Region = "REGION",
}
